export default __webpack_public_path__ + "static/media/icon_schedule_pressed.260db517.svg";